import { processCaptions } from 'utils/utils';

export default class LevelSeek extends Phaser.State {
  init({ levelData, seekerId }) {
    this.levelData = levelData;
    this.seekerId = seekerId;
    this.locationData = this.game.cache.getJSON('location_data');

    // captions - prepare data
    this.cptData = this.game.cache.getJSON(seekerId + '_captions');
    this.cptData = processCaptions(this.game, this.cptData, seekerId + '_vo-audioatlas');

    /*
    const vosData = this.game.cache.getJSON(seekerId + '_vo-audioatlas');

    for (const key in this.cptData) {
      if (this.cptData.hasOwnProperty(key)) {
        const cpt = this.cptData[key][0];
        const vo = vosData.spritemap[key];
        cpt.start = 0;
        if (vo) {
          cpt.end = (vo.end - vo.start) * 1000 + 100;
        } else {
          cpt.end = 0;
        }
        // dirty fix for vo_017 - 'Nice hiding place [character name]'
        if (key.indexOf('_017') >= 0) {
          cpt.end += 2000; // add additional time
        }
      }
    }
    */
    this.game.springRollCaptionsPlugin.setData(this.cptData);

    //
    this.game.scale.onSizeChange.add(this.handleResize, this);

    //
    this.game.sounds.playSFX('loop', { loop: true, spriteID: 'sfx_location' });
  }

  handleResize() {}

  //
  calculateNavPoints() {
    const x0 = this.game.width * 0.5;
    const x1 = this.levelData.sceneWidth - this.game.width * 0.5;
    const dx = x1 - x0;
    this.navPoints = [];

    if (dx < this.game.width) {
      // distance between edges smaller than screen width
      this.navPoints.push(x0);
      this.navPoints.push(x1);
    } else {
      //
      const screens = Math.round(dx / this.game.width) + 1;
      const width = dx / screens;
      for (let i = 0; i < screens + 1; i++) {
        this.navPoints[i] = x0 + width * i;
      }
    }
  }

  setCurrentNavPoint() {
    const cx = this.camera.currentX;
    const x0 = this.game.width * 0.5;
    const x1 = this.levelData.sceneWidth - this.game.width * 0.5;

    if (cx < x0) {
      this.navPointId = 0;
    } else if (cx > x1) {
      this.navPointId = this.navPoints.length - 1;
    } else {
      const width = this.navPoints[1] - this.navPoints[0];

      for (let i = 0; i < this.navPoints.length; i++) {
        const dx = Math.abs(this.navPoints[i] - cx);
        if (dx < width * 0.5) {
          this.navPointId = i;
          break;
        }
      }
    }

    // const screens = Math.ceil((this.levelData.sceneWidth - this.game.width) / this.game.width);
    // const w = this.levelData.sceneWidth / screens;
    // const x = this.camera.currentX;
    // for (let i = 0; i < this.navPoints.length; i++) {
    //   const dx = Math.abs(this.navPoints[i] - x);
    //   if (dx < w * 0.5) {
    //     this.navPointId = i;
    //     break;
    //   }
    // }

    // console.log('this.navPointId', this.navPointId);
  }

  shutdown() {
    this.game.scale.onSizeChange.remove(this.handleResize, this);
    this.game.sounds.stopAudioSprite('loop', { spriteID: 'sfx_location' });
  }
}
